import React, {useRef, useState} from 'react';
import { useAuth, useMedia, upload } from 'api';
import { Text, Button, Card, Loading, Header } from 'ui';
import { yellow } from 'config/colors';
import "./index.css";

export default function Media(props) {
  const auth = useAuth();
  const media = useMedia(auth ? auth.company.id : null);
  const [uploading, setUploading] = useState(false);
  const uploaderRef = useRef();
  
  async function handleUploaderChange(e) {
    if(uploading) {
      return;
    }
    const companyId = auth.company.id;
    setUploading(true);
    for(const file of e.target.files) {
      await upload(companyId, file);
    }
    setUploading(false);
  }
  
  if(!media) {
    return (
      <div className="media">
        <Header>
          <Text large light style={{flex:1}}>Media Library</Text>
          <Button style={{backgroundColor:yellow}} onClick={() => uploaderRef.current.click()}>
            <Text small>
              {uploading ? "UPLOADING..." : "UPLOAD MEDIA"}
            </Text>
          </Button>
          <input type="file" onChange={handleUploaderChange} style={{display:'none'}} ref={uploaderRef} multiple={true}/>
        </Header>
        <Loading/>
      </div>
    );
  }
  
  if(media.length === 0) {
    return (
      <div className="media-placeholder">
        <Header>
          <Text large light style={{flex:1}}>Media Library</Text>
          <Button style={{backgroundColor:yellow}} onClick={() => uploaderRef.current.click()}>
            <Text small>
              {uploading ? "UPLOADING..." : "UPLOAD MEDIA"}
            </Text>
          </Button>
          <input type="file" onChange={handleUploaderChange} style={{display:'none'}} ref={uploaderRef} multiple={true}/>
        </Header>
          
        <div className="media-placeholder-body">
          <Text huge block>Upload Media To Use In Your Campaigns</Text>
          <Text block>
          </Text>
          <Button onClick={() => uploaderRef.current.click()} style={{backgroundColor:"white", marginBottom:40}}>
            <Text color="#243746">Upload Images and Logos</Text>
          </Button>
        </div>
        
      </div>
    );
  }
  
  return (
    <div className="media">
      <Header>
        <Text large light style={{flex:1}}>Media Library</Text>
        <Button style={{backgroundColor:yellow}} onClick={() => uploaderRef.current.click()}>
          <Text small>
            {uploading ? "UPLOADING..." : "UPLOAD MEDIA"}
          </Text>
        </Button>
        <input type="file" onChange={handleUploaderChange} style={{display:'none'}} ref={uploaderRef} multiple={true}/>
      </Header>
      <div style={{padding:24}}>
        <div className="media-grid">
          {media.map(item => 
            <Card className="media-item" key={item.id}>
              {item.url && <img src={item.url} alt="" className="media-item-image"/>}
              {item.progress && 
                <div className="media-item-progress">
                  <Text white>{Math.round(item.progress)}%</Text>
                </div>
              }
            </Card>
          )}
        </div>
      </div>
    </div>
  );
  
}